import { getCurrentInstance, computed } from "vue";


export const useI18n = () => {
    const vm = getCurrentInstance();
    if (!vm) throw new Error("must be called in setup");
    const traduction = computed(() => vm.proxy.$i18n);
    return traduction.value;
};